import { useState } from 'react';
import { Button } from '@mui/material';
// import toast from 'react-hot-toast';
import HttpClient from '../../../utils/HttpClient';
// import ImageModal from './Image View Modal/ImageModal';

export const FourthForm = ({ onNext, onBack, formFourthData, setFormFourthData }) => {
    const [SelectedImage, setSelectedImage] = useState(null)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const handleView = async (item) => {
        setSelectedImage(item);
        setIsModalOpen(true);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        // Process form data
        // const values = Object.values(formFourthData);
        // if (values.includes("")) {
        //     toast.error("Empty Field detected");
        //     return; // Stop further execution
        // }

        onNext();
    };

    const handleChange = async (e) => {
        const { name, files } = e.target;
        if (files && files.length > 0) {
            // File is selected, perform image upload
            const formData = new FormData();
            formData.append("image", files[0]);
            const res = await HttpClient.fileUplode("image-upload", "POST", formData);
            if (res && res.status) {
                // Update state with the URL of the uploaded image

                setFormFourthData(prev => ({
                    ...prev,
                    [name]: res?.data?.url
                }));
            }
        }
    };

    return (
        <form >
            <div className="row">
                <div className="col-md-12 mt-3 ">
                    <label style={{ marginRight: "65px" }}>Banner<span className="text-danger"> (1000 x 400 px)&nbsp;*</span>:</label>
                    <input
                        type="file"
                        // className="form-control"
                        placeholder="banner"
                        name="banner"
                        // value={formFourthData.banner}
                        onChange={(e) => handleChange(e)}
                        required
                    />

                    <img src={formFourthData.banner} alt="" id="preview" height="70px" width="70px" className="mb-2"
                        onClick={() => handleView(formFourthData?.banner)} />

                </div>
                <div className="col-md-12 mt-3 ">
                    <label style={{ marginRight: "22px" }}>Profile Photo:<span className="text-danger">(120 × 120 px)&nbsp;*</span></label>
                    <input
                        type="file"
                        className="mx-1"
                        placeholder="profilePhoto"
                        name="profilePhoto"
                        // value={formFourthData.profilePhoto}
                        onChange={(e) => handleChange(e)}
                        required
                    />
                    <img src={formFourthData?.profilePhoto} alt="" id='preview' height="70px" width="70px" className='mb-2'
                        onClick={() => handleView(formFourthData?.profilePhoto)} />
                </div>

            </div>
            {/* Your form fields for the second step */}
            <Button onClick={onBack} variant="contained" className='mx-2 mt-2'>
                Back
            </Button>
            <Button onClick={handleSubmit} variant="contained" color="primary" className='mx-2 mt-2'>
                Next
            </Button>
            {/* <ImageModal isOpen={isModalOpen} closeModal={() => setIsModalOpen(false)}
                SelectedImage={SelectedImage} /> */}
        </form>

    )
}
